import React, { Component, Fragment  } from 'react';
import { Link } from 'react-router-dom';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';


class TermsParItem extends Component {

  render() {
    var list = this.props.list;
    return (
      list.map((item,index)=> (
        (item.list) ?
          <li key={index}>
            <p>{item.content}</p>
            <ul>
              <TermsParItem list={item.list} />
            </ul>
          </li>
          :
          <li key={index}>
            <p>
              {item.content}
            </p>
          </li>
      ))
    );
  }
}

class TermsAndConditions extends Component {

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.landing.termsAndConditions.' + key + '.list');
  }

  render() {
    return (
      <div className="content">
        <div className="row row--text">
          <div className="headline headline--subpage">
            <h1><T>content.landing.termsAndConditions.title</T></h1>
            <p><T>content.landing.termsAndConditions.desc</T></p>
          </div>

          <ol className="terms-list">
            <li className="terms-list__item">
              <h3><T>content.landing.termsAndConditions.general.title</T></h3>
              <ol><TermsParItem list={this.trans('general')} /></ol>
            </li>
            <li className="terms-list__item">
              <h3><T>content.landing.termsAndConditions.booking.title</T></h3>
              <ol><TermsParItem list={this.trans('booking')} /></ol>
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.termsAndConditions.carrier.title</T></h3>
              <ol><TermsParItem list={this.trans('carrier')} /></ol>
            </li>
            <li className="terms-list__item">
              <h3><T>content.landing.termsAndConditions.passengers.title</T></h3>
              <ol><TermsParItem list={this.trans('passengers')} /></ol>
            </li>
          </ol>
        </div>
      </div>
    );
  }
}

export default TermsAndConditions;
